// tsc does not recognize jsx extension therefor renaming to tsx
import AuthProvider from '../providers/AuthProvider';

/**
 * Starts signin request
 * @returns {AuthConsumer}
 * @constructor
 */
export const SignIn = () => AuthProvider.createConsumer('signInRequest', 'Ajax.signinRedirectMessage');
